export default function duplicateItem(array, index) {
  if (!Array.isArray(array)) return array;
  const newArray = [...array];
  if (index < 0 || index >= newArray.length) return array;
  
  // Clone item deeply
  const cloned = JSON.parse(JSON.stringify(newArray[index]));
  
  // Add copy tags to identifier keys
  if (cloned.company) cloned.company = `${cloned.company} (Copy)`;
  else if (cloned.name) cloned.name = `${cloned.name} (Copy)`;
  else if (cloned.title) cloned.title = `${cloned.title} (Copy)`;
  else if (cloned.college) cloned.college = `${cloned.college} (Copy)`;
  else if (cloned.institution) cloned.institution = `${cloned.institution} (Copy)`;

  newArray.splice(index + 1, 0, cloned);
  return newArray;
}
